import { memo } from 'react';
import { Focusable } from 'react-aria-components';

import { Text, TextProps, Tooltip, TooltipTrigger } from '@/components/core';
import { formatDate, formatDateFull, OmitChildren } from '@/utils';

export type DateTimeProps = OmitChildren<TextProps> & {
  date?: Date | null;
  disableTooltip?: boolean;
};

const IDateTime = ({ date, disableTooltip, className, ...rest }: DateTimeProps) => {
  if (!date) return <div className="h-3 w-14 animate-pulse rounded-lg bg-gray-200" />;

  return disableTooltip ? (
    <Text className={className} {...rest}>
      {formatDate(date)}
    </Text>
  ) : (
    <TooltipTrigger>
      <Tooltip>
        <Text>{formatDateFull(date)}</Text>
      </Tooltip>
      <Focusable>
        <Text role="button" className={className} {...rest}>
          {formatDate(date)}
        </Text>
      </Focusable>
    </TooltipTrigger>
  );
};

export const DateTime = memo(IDateTime) as typeof IDateTime;
